// Category scope choices on the Add and Edit Category forms. The server
// (backend/utils/categoryScope.js) enforces the same rules; this only labels them.
export const SCOPE_BUSINESS = 'business';
export const SCOPE_ALL = 'all';

export const SCOPE_HELP = {
  [SCOPE_BUSINESS]: 'This business only: the category shows and can be used only in the business chosen here, never in your other businesses.',
  [SCOPE_ALL]: 'All my businesses: the category shows in every business you have.'
};

// Built-in categories every business can use (read-only).
export const isBuiltIn = (c) => !c.business_id && (c.user_id === null || c.user_id === undefined || c.is_system === true);

export const scopeOf = (c) => (c && c.business_id ? SCOPE_BUSINESS : SCOPE_ALL);

export function scopeLabel(c, businesses) {
  if (isBuiltIn(c)) return 'Built-in';
  if (!c.business_id) return 'All my businesses';
  const found = (businesses || []).find((b) => Number(b.id) === Number(c.business_id));
  return found ? `Only ${found.name || found.business_name || 'this business'}` : 'This business only';
}

// The business a new category is for: the one picked in the sidebar, else the first.
export function defaultBusinessId(selected, businesses) {
  const list = Array.isArray(businesses) ? businesses : [];
  if (selected && list.some((b) => Number(b.id) === Number(selected))) return Number(selected);
  return list.length ? Number(list[0].id) : null;
}

// What the API gets: scope, and the business it is for. An all-businesses save still
// names a business, because every write names the location it is made from.
export function categoryPayload(form) {
  const { name, type, color, icon, scope, business_id } = form;
  return { name, type, color, icon, scope: scope === SCOPE_ALL ? SCOPE_ALL : SCOPE_BUSINESS, business_id: business_id || undefined };
}